import { CommApiInstance } from "Utils/CommApiInstance";

const CommuBrdPstdLstApi = async (
    brdCd:string,
    brdCtgrCd:string,
) => {
    return await CommApiInstance.post(`brd/BBO/${brdCd}/pstd_lst?brdCtgrCd=${brdCtgrCd}`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default CommuBrdPstdLstApi;